<template>
  <div class="site">
    <div class="site__toggle">
      <toggle
        :value="getValue"
        :options="options"
        @change="goToPage"
      />
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import store from '@/store';
import Toggle from '@/components/Toggle.vue';

export default {
  name: 'ManageSite',
  components: {
    Toggle,
  },
  data() {
    return {
      options: [
        'About',
        'Contact',
        'Press',
        'Options',
      ],
    };
  },
  computed: {
    getValue() {
      return this.$route.name.split('Manage')[1];
    },
  },
  beforeRouteEnter: (to, from, next) => {
    store.dispatch('fetchSite').then(() => next());
  },
  methods: {
    goToPage(route) {
      const toRoute = `Manage${route}`;
      if (toRoute !== this.$route.name) {
        this.$router.push({ name: toRoute });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.site {
  max-width: 600px;
  margin: 0 auto;
  &__toggle {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
  }
}
</style>
